module.exports = __webpack_public_path__ + "media/assets/icons/chevron-down-4a4d60e860c80dcf4eaf3e6b2b997c49.svg";